const ORBIT_SPEED = 0.005
const PAN_SPEED = 0.001
const ZOOM_SPEED = 0.00075
const LMB = 1 // bitmask
const RMB = 2 // bitmask

export class EditorAssetOrbit {
  constructor(studio) {
    this.studio = studio
    this.camera = studio.camera
    this.rig = studio.rig
    this.viewport = studio.viewport
    this.viewport.addEventListener('pointerdown', this.onPointerDown)
    this.viewport.addEventListener('pointermove', this.onPointerMove)
    this.viewport.addEventListener('pointerup', this.onPointerUp)
    this.viewport.addEventListener('pointercancel', this.onPointerCancel)
    this.viewport.addEventListener('lostpointercapture', this.onPointerLost)
    this.viewport.addEventListener('contextmenu', this.onContextMenu)
    this.viewport.addEventListener('wheel', this.onWheel, { passive: false })
    this.orbiting = false
    this.panning = false
    this.freeze = false
    this.zoom = this.camera.position.z
  }

  onPointerDown = e => {
    this.viewport.setPointerCapture(e.pointerId)
    const left = !!(e.buttons & LMB)
    const right = !!(e.buttons & RMB)
    if (left) {
      this.orbiting = true
      // console.log('orbit start')
    }
    if (right) {
      this.panning = true
      // console.log('pan start')
    }
  }

  onPointerMove = e => {
    if (this.freeze) {
      return
    }
    if (this.orbiting) {
      // console.log('orbit move')
      this.rig.rotation.y -= e.movementX * ORBIT_SPEED
      this.rig.rotation.x -= e.movementY * ORBIT_SPEED
    }
    if (this.panning) {
      // console.log('pan move')
      const panSpeed = this.zoom * PAN_SPEED

      // forward (normalized)
      const forward = new THREE.Vector3()
      this.camera.getWorldDirection(forward)

      // right = forward × up
      const right = new THREE.Vector3().crossVectors(forward, this.camera.up).normalize()

      // up = right × forward (guarantees it's perpendicular to forward too)
      const up = new THREE.Vector3().crossVectors(right, forward).normalize()

      // now move rig only in the screen plane (right & up, no forward)
      this.rig.position.addScaledVector(right, -e.movementX * panSpeed)
      this.rig.position.addScaledVector(up, e.movementY * panSpeed)
    }
  }

  onPointerUp = e => {
    this.endPointer(e)
  }

  onPointerCancel = e => {
    this.endPointer(e)
  }

  onPointerLost = e => {
    this.endAllPointers()
  }

  onContextMenu = e => {
    e.preventDefault()
  }

  onWheel = e => {
    let delta = e.shiftKey ? e.deltaX : e.deltaY
    const factor = Math.exp(-delta * ZOOM_SPEED) // <1 for positive deltaY (zoom in)
    this.zoom = this.zoom * factor
    // this.zoom += delta * ZOOM_SPEED
    this.camera.position.z = this.zoom
  }

  endPointer(e) {
    if (this.viewport.hasPointerCapture?.(e.pointerId)) {
      this.viewport.releasePointerCapture(e.pointerId)
    }
    const left = !!(e.buttons & LMB)
    const right = !!(e.buttons & RMB)
    if (this.orbiting && !left) {
      this.orbiting = false
      // console.log('orbit stop')
    }
    if (this.panning && !right) {
      this.panning = false
      // console.log('pan stop')
    }
  }

  endAllPointers() {
    if (this.orbiting) {
      this.orbiting = false
      // console.log('orbit stop')
    }
    if (this.panning) {
      this.panning = false
      // console.log('pan stop')
    }
  }

  destroy() {
    this.viewport.removeEventListener('pointerdown', this.onPointerDown)
    this.viewport.removeEventListener('pointermove', this.onPointerMove)
    this.viewport.removeEventListener('pointerup', this.onPointerUp)
    this.viewport.removeEventListener('pointercancel', this.onPointerCancel)
    this.viewport.removeEventListener('lostpointercapture', this.onPointerLost)
    this.viewport.removeEventListener('contextmenu', this.onContextMenu)
    this.viewport.removeEventListener('wheel', this.onWheel, { passive: false })
  }
}
